import React from "react";
import { Layout } from "antd";

interface Props {
  children: React.ReactNode;
}

const Content: React.FC<Props> = ({ children }) => {
  return <Layout.Content className="content">{children}</Layout.Content>;
};

export default Content;
